import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedSchool: null
};

const geniusSchoolSlice = createSlice({
  name: "geniusSchool",
  initialState,
  reducers: {
    setSelectedSchool: (state, action) => {
      state.selectedSchool = action.payload;
    },
    clearSelectedSchool: (state) => {
      state.selectedSchool = null;
    }
  }
});

export const { setSelectedSchool, clearSelectedSchool } = geniusSchoolSlice.actions;
export default geniusSchoolSlice.reducer;
